module.exports = __webpack_public_path__ + "images/b57aa8e8cf7ee1d791fe35b80e20bfc2.png";